/* Lazy playback for the videos in the "What happens" cards.

   Both cards sit well below the fold. With a plain autoplay attribute the browser
   downloads them on page load, so a phone pays for them before anyone scrolls.
   These start at preload="none" behind a poster frame and only fetch and play once
   they come near the viewport.

   Falls back to immediate playback where IntersectionObserver is unavailable. */

(function(){
  function start(v){
    if(v.getAttribute("data-vap-started") === "1") return;
    v.setAttribute("data-vap-started", "1");
    v.preload = "auto";
    var p = v.play();
    if(p && p.catch){ p.catch(function(){ /* autoplay refused, poster stays */ }); }
  }

  function boot(){
    var vids = document.querySelectorAll("#vap .vap-video video[data-vap-lazy]");
    if(!vids.length) return;

    if(!("IntersectionObserver" in window)){
      for(var i=0;i<vids.length;i++){ start(vids[i]); }
      return;
    }

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          start(e.target);
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: "300px 0px" });

    for(var j=0;j<vids.length;j++){ io.observe(vids[j]); }
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", boot);
  }else{
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
